import { createSlice } from '@reduxjs/toolkit';
import { createFilterInitialState, filterReducers, FilterState } from 'common/utils/sliceUtils/filterSliceUtils';

type StateWithTenants = { tenants: FilterState };

const tenantsSlice = createSlice({
    name: 'tenants',
    initialState: createFilterInitialState(),
    reducers: () => ({
        ...filterReducers,
    })
});

// eslint-disable-next-line no-restricted-syntax
export default tenantsSlice.reducer;
export const { addNewFilter, removeFilter, clearFilters } = tenantsSlice.actions;
export const selectFilters = (state: StateWithTenants) => state.tenants.filters;
